/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { Loader, DropDownWrapper, Each } from 'components';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { DropDownItem } from './DropDownItem';
import { useSelector } from 'react-redux';
import { revenueReportsAPI } from 'services/reports.service';
import { publisherReportsRequestTypes } from 'constants';

const checkValue = (value, search) => {
  return value?.toString().toLowerCase().includes(search.toLowerCase());
};

export const DropDownMenu = ({
  dropDownIsOpen$,
  containerRef,
  searchValue,
  appNumberIsSelected,
  toggleSelectedAppNumber,
  searchValue$,
}) => {
  const periodFrom = useSelector((state) => state.reports.selectedDateRangeReports.from);
  const periodTo = useSelector((state) => state.reports.selectedDateRangeReports.to);

  const { data, isLoading, uniqueAppsArr } = revenueReportsAPI.useGetReportQuery(
    {
      to: periodTo,
      from: periodFrom,
      type: publisherReportsRequestTypes.applications,
    },
    {
      selectFromResult: (response) => {
        const uniqueAppsArr = [];
        const uniqueIdsSet = new Set([]);
        response.data.revenueData.rows.forEach((item) => {
          const currentPba_number = item.pba_number;
          if (!uniqueIdsSet.has(currentPba_number)) {
            uniqueIdsSet.add(currentPba_number);
            uniqueAppsArr.push(item);
          }
        });

        return { ...response, uniqueAppsArr };
      },
    },
  );

  const filteredApps = useMemo(() => {
    if (searchValue.length < 2) return uniqueAppsArr;
    return uniqueAppsArr.filter((appRow) => {
      return (
        checkValue(appRow.apps, searchValue) ||
        checkValue(appRow.pba_number, searchValue) ||
        checkValue(appRow.package, searchValue)
      );
    });
  }, [searchValue, uniqueAppsArr]);

  return (
    <DropDownWrapper
      isOpen$={dropDownIsOpen$}
      width={350}
      targetRef={containerRef}
      style={{
        top: '60px',
        left: '0px',
      }}
      outSideClickAction={() => {
        searchValue$.value = '';
      }}
    >
      <ContentBox>
        {isLoading ? (
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <Loader.Local delay={0} />
          </div>
        ) : (
          <>
            <Title>Applications:</Title>
            {filteredApps.length ? (
              <Each
                fieldOfIndex='pba_number'
                of={filteredApps}
                render={(item, index) => {
                  return (
                    <DropDownItem
                      {...item}
                      searchValue={searchValue}
                      appNumberIsSelected={appNumberIsSelected}
                      toggleSelectedAppNumber={toggleSelectedAppNumber}
                    />
                  );
                }}
              />
            ) : (
              <div style={{ textAlign: 'center' }}>No filtered Apps.</div>
            )}
          </>
        )}
      </ContentBox>
    </DropDownWrapper>
  );
};

const ContentBox = styled.div`
  height: auto;
  max-height: 240px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;

const Title = styled.p`
  color: ${Palette.PrimaryGray._400};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
